(function () {
  const formControls = document.getElementsByClassName("custom-form-colors");
  if(formControls.length > 0) {
    const selectElements = formControls[0].getElementsByClassName("form-select")
    const selectElementsarr = Array.prototype.slice.call(selectElements);
    if (selectElementsarr) {
      selectElementsarr.forEach((select) => {
        select.addEventListener("change", (event) => {
          if (event.target.options.selectedIndex == 0) {
            event.target.classList.add("select-default-option-");
            event.target.classList.remove("select-option-color");
          } else {
            event.target.classList.add("select-option-color");
            event.target.classList.remove("select-default-option");
          }
        });
      });
    }
  }
  
})();
